import { LoadingSpinner } from "components/LoadingSpinner";
import { useGetPlasticsReportsUrlQuery } from "store/queries/analytics";

interface IPlasticsReportsDashboardProps {
  accountId: string;
}

export function PlasticsReportsDashboard({
  accountId,
}: IPlasticsReportsDashboardProps) {
  const { data, isLoading } = useGetPlasticsReportsUrlQuery(
    { accountId },
    { skip: !accountId }
  );

  if (isLoading) {
    return <LoadingSpinner />;
  }

  return (
    <div
      style={{
        width: "100%",
        height: "2800px",
        padding: "0",
        margin: "0",
      }}
    >
      {data?.data?.iframeUrl && (
        <iframe
          src={data.data.iframeUrl}
          frameBorder="0"
          width="1400"
          height="2800"
          title="Doctor Revenue"
        />
      )}
    </div>
  );
}
